import type { AllocationStatus } from '@/types/api'

const statusConfig: Record<AllocationStatus, { dot: string; bg: string; text: string; label: string }> = {
  NORMAL: {
    dot: 'bg-brand-green',
    bg: 'bg-brand-green/8',
    text: 'text-brand-green',
    label: 'Normal',
  },
  SOFT_CAP_WARNING: {
    dot: 'bg-brand-yellow',
    bg: 'bg-brand-yellow/8',
    text: 'text-brand-yellow',
    label: 'Warning',
  },
  OVERFLOW_ACTIVE: {
    dot: 'bg-brand-blue',
    bg: 'bg-brand-blue/8',
    text: 'text-brand-blue',
    label: 'At Cap',
  },
  HARD_STOP: {
    dot: 'bg-brand-red',
    bg: 'bg-brand-red/8',
    text: 'text-brand-red',
    label: 'Hard Stop',
  },
}

interface StatusBadgeProps {
  status: AllocationStatus
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const config = statusConfig[status]
  return (
    <span
      className={`
        inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full
        text-xs font-medium
        ${config.bg} ${config.text}
      `}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${config.dot}`} />
      {config.label}
    </span>
  )
}
